export const BaseUrl = "https://api.kahayfaqeer.com";
// export const BaseUrl = "https://api-dev.kahayfaqeer.com";
// export const BaseUrl = "https://test.saqlainhaider.online";
// export const BaseUrl = "http://localhost:3000";
export const PicBaseUrl = "https://example.com";
export const LiveBaseUrl = "https://example.com";


